let validateFile = (maxPdfSize, maxFiles, filesLength, file) => {
    let whiteList = ['application/pdf', 'image/jpeg', 'image/png']
    if (whiteList.indexOf(file.type) === -1) {
        return {
            message: `Nieprawidłowy <br/> format pliku`,
            error  : true
        }
    }
    if ( file.size > maxPdfSize ) {
        return {
            message: `Nieprawidłowy <br/> rozmiar pliku`,
            error  : true
        }
    }
     if ( filesLength < maxFiles ) {
        return {
            message: `Przeciągnij plik / <br /> Wczytaj z dysku`,
            error  : false
        }
    } else {
        return {
            message: `Osiągnięto <br/> limit plików`,
            error  : true
        }
     }
}

export default validateFile;